import { render, staticRenderFns } from "./LayoutRight2.vue?vue&type=template&id=326ed400"
import script from "./LayoutRight2.vue?vue&type=script&lang=js"
export * from "./LayoutRight2.vue?vue&type=script&lang=js"
import style0 from "./LayoutRight2.vue?vue&type=style&index=0&id=326ed400&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports